export default "__VITE_ASSET__oIb6wdjL__ 800w";